Drupal.behaviors.organisms = {
  attach(context) {
    const contentTabSwitchSelector = '.js-content-tab-switch';
    const isNotLayoutBuilder = '.is-not-layout-builder';
    const processedClass = 'js-content-tab-switch--is-processed';


    if (document.getElementsByTagName("BODY")[0].matches(isNotLayoutBuilder)) {
      const getPreviousUntil = function (elem, selector) {
        // Start with the current element
        let current = elem;

        // Loop as long as there's a node
        while (current) {
          // If the current node matches the selector, return it
          if (selector && current.matches(selector)) {
            return current;
          }

          // If there's a previous sibling, move to it
          if (current.previousElementSibling) {
            current = current.previousElementSibling;
          } else {
            // If there are no more siblings, move up to the parent
            // If there's no parent, this will terminate the loop as current becomes null
            current = current.parentElement;
          }
        }

        // If we've reached here, we've gone through all the ancestors and siblings in reverse order and found no match
        return null;
      };

      const tabItems = document.querySelectorAll('[js-content-tab-id]');
      const tabHierachy = [];

      tabItems.forEach(tabItem => {
        if (!tabItem.classList.contains('tabitem--processed')) {
          tabItem.classList.add('tabitem--processed')
          
          const parent = getPreviousUntil(tabItem, contentTabSwitchSelector);
          const parentId = parent.getAttribute('id');
          tabHierachy[parentId] = tabHierachy[parentId] || [];
          tabHierachy[parentId].push({parent, tabItem})
        }
      })

      Object.keys(tabHierachy).forEach((parentId, parentIndex) => {
        const contentTabs = document.querySelectorAll(contentTabSwitchSelector);
        tabHierachy[parentId].forEach((tabConfig, index) => {
          const parent = tabConfig.parent;
          const child = tabConfig.tabItem;
          const template = parent.querySelector('.js-content-tab-btn-template');
          let tabButtonFragment = template.content.cloneNode(true);
          let tabButton = tabButtonFragment.children[0];
          tabButton.classList.add('tab-content-button');
          tabConfig.tabButton = tabButton;
          tabButton.querySelector('.js-content-tab-btn-title').innerHTML = child.getAttribute('js-content-tab-label');
          let iconContainer = tabButton.querySelector('.js-content-tab-btn-icon');
          iconContainer.innerHTML = child.getAttribute('js-content-tab-icon');
          let svgElement = iconContainer.querySelector('svg');
          if (svgElement) {
            svgElement.classList.add('fill-current', 'w-7', 'h-7', 'mr-4');
          }

          tabButton.addEventListener("click", function() {

            tabHierachy[parentId].forEach(innerTabConfig => {
              innerTabConfig.tabItem.classList.add('hide-tab-content');
              innerTabConfig.tabButton.classList.remove('tab-content-active');
              child.classList.remove('hide-tab-content');
              tabButton.classList.add('tab-content-active');
            })
          });

          parent.querySelector('.js-content-tab-switch-btn-group').append(tabButton)

          if (index !== 0) {
            child.classList.add('hide-tab-content');
          }

          if (index === 0) {
            child.classList.remove('hide-tab-content');
            tabButton.classList.add('tab-content-active');
          }
        })
      })
    }
  },
};
